import ProductEdit from "features/Product/ProductEdit/ProductEdit";

const ProductEditPage: React.FC = () => {
  return <ProductEdit />;
};

export default ProductEditPage;
